import { useMemo } from 'react';

import { AppStore } from '@shared/store';

import { AppFeature, useIsFeatureEnabled } from 'src/config';
import { useMarkets } from 'src/lib/markets/hooks/useMarkets';

export const useEligibleForLoansAssets = () => {
  const { assetsInitialized } = AppStore.useAppStore;
  const { isFeatureEnabled } = useIsFeatureEnabled();
  const loansEnabled = isFeatureEnabled(AppFeature.CryptoBackedLoans);
  const { getAssetsByCode } = useMarkets();

  return useMemo(() => {
    if (!assetsInitialized || !loansEnabled) return [];

    // Add to list when new assets are added to loans product
    const assetCodes = ['BTC']; // extend this list as needed

    return getAssetsByCode(assetCodes);
  }, [assetsInitialized, loansEnabled, getAssetsByCode]);
};
